/**
* @file 旅游包车 - 一级菜单入口（重定向到包车订单子页面）
* */
<template>
  <div></div>
</template>

<script>
export default {
  name: "charteredFrame",
  created() {
    this.$router.replace('/charteredOrder');
  }
};
</script>
